// extracted by mini-css-extract-plugin
export var blue = "TicketsCard-module--blue--pmIT5";
export var details = "TicketsCard-module--details--0o5ZY";
export var gray = "TicketsCard-module--gray--2UaJn";
export var green = "TicketsCard-module--green--l5AXr";
export var heading = "TicketsCard-module--heading--5P6Kg";
export var orange = "TicketsCard-module--orange--R6CpP";
export var price = "TicketsCard-module--price--L4JGd";
export var pricingInfo = "TicketsCard-module--pricingInfo--V5U+e";
export var root = "TicketsCard-module--root--BlMSX";
export var title = "TicketsCard-module--title--tqr45";